function initEmblaInDrawer(drawerEl) {
  if (window.initEmblaCarousel) {
    drawerEl.querySelectorAll('.embla').forEach(node => {
      if (node._emblaApi) {
        node._emblaApi.destroy();
        node._emblaApi = null;
      }
      node._emblaApi = window.initEmblaCarousel(node);
    });
  }
}

function openCartDrawer() {
  const drawer = document.querySelector(".cart-drawer");
  drawer.classList.add("cart-drawer--active");

  initEmblaInDrawer(drawer);

  let chatClose = document.getElementById('shopify-chat');
  if (chatClose) chatClose.style.visibility = 'hidden';

  const teaser = document.querySelector('[data-testid="animated-teaser"]');
  if (teaser) teaser.style.display = 'none';
  document.body.classList.add('overflow-hidden');

  updateCartDrawer();
}
window.openCartDrawer = openCartDrawer;

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
    let chatClose = document.getElementById('shopify-chat');    
  if (chatClose) chatClose.style.visibility = 'visible';

  const teaser = document.querySelector('[data-testid="animated-teaser"]');
  if (teaser) teaser.style.display = '';
  document.body.classList.remove('overflow-hidden');
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}
window.updateCartItemCounts = updateCartItemCounts;

async function renderCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".cart-drawer").innerHTML;
  const drawerEl = document.querySelector(".cart-drawer");
  drawerEl.innerHTML = newBox;

  addCartDrawerListeners();
  discountCodeApplying();
  window.updateCartCount();
  initEmblaInDrawer(drawerEl);
}

// Renders the drawer and, when we are on the cart page, the page itself, so the
// two never show a different cart after a change in either one.
async function renderCartSurfaces() {
  await renderCartDrawer();
  await window.renderCartPage?.();
}

async function updateCartDrawer(cartData = null) {
  // 1) Render immediately with current cart state (no sync blocking)
  await renderCartSurfaces();

  // 2) Sync gifts in background — uses pre-fetched cart if available
  const changed = await window.CartGiftManager?.sync(cartData);

  // 3) Re-render only if gifts were added or removed
  if (changed) await renderCartSurfaces();
}

window.updateCartDrawer = updateCartDrawer;

function addCartDrawerListeners() {
  // Discount toggle
  const discountToggle = document.querySelector(".cart-drawer__discount-toggle");
  const discountContent = document.querySelector(".cart-drawer__discount-content");
  if (discountToggle && discountContent) {
    discountToggle.addEventListener("click", () => {
      const isOpen = discountToggle.classList.toggle("cart-drawer__discount-toggle--open");
      discountContent.style.maxHeight = isOpen ? discountContent.scrollHeight + "px" : "0px";
      if (!isOpen) {
        const input = document.getElementById("discount-code");
        const message = document.getElementById("discount-message");
        const label = document.getElementById("discount-section__label");
        if (input) { input.value = ""; input.style.border = ""; }
        if (message) message.textContent = "";
        if (label) label.style.color = "";
      }
    });
  }

  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key        
        let quantitySpinner = button.parentElement.querySelector('.quantity-spinner')

        if(quantitySpinner) {
          quantitySpinner.style.display = 'block';
        }
        const rootItem = button.closest(".cart-lineitem");

        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);
        
        // Update cart
        updateCartDrawer(cart);
      });
    });

  document
    .querySelectorAll(".cart-drawer-quantity-selector input[type='number']")
    .forEach((input) => {
      input.addEventListener("change", async (e) => {
        let quantitySpinner = input.parentElement.querySelector('.quantity-spinner')

        if(quantitySpinner) {
          quantitySpinner.style.display = 'block';
        }
        // parsiraj i validiraj novo quantity
        let newQuantity = parseInt(e.target.value, 10);
        if (isNaN(newQuantity) || newQuantity < 1) newQuantity = 1;
        e.target.value = newQuantity;

        // nađi key iz roditeljskog .cart-lineitem elementa
        const rootItem = input.closest(".cart-lineitem");
        const key = rootItem.getAttribute("data-line-item-key");

        // pošalji update na Shopify
        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();
        // update broja u badge-ovima i reload drawer-a
        updateCartItemCounts(cart.item_count);
        await updateCartDrawer(cart);
      });
    });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        closeCartDrawer();
      });
    });

  document.querySelectorAll('.cart-drawer form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      let spinner = e.target.querySelector('.cart-drawer-upsell-item__btn .spinner');
      if (spinner) spinner.style.display = 'block';

      const formData = new FormData(form);
      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      });

      if (!addRes.ok) {
        console.error("Add to cart failed");
        if (spinner) spinner.style.display = 'none';
        return;
      }

      const added = await addRes.json();
      const qtyJustAdded = getAddedQuantityFromFormData(formData);
      fillCartNotification(added, qtyJustAdded);
      openCartNotification();
      await updateCartDrawer();
    });
  });
}

addCartDrawerListeners();
discountCodeApplying();

// On initial page load, sync gifts first (cart state unknown), then render once if changed.
(async () => {
  if (!window.CartGiftManager) return;
  const changed = await window.CartGiftManager.sync();
  if (changed) await renderCartDrawer();
})();

// document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
//   form.addEventListener("submit", async (e) => {
//     e.preventDefault();

//     // Submit form with ajax
//     await fetch("/cart/add", {
//       method: "post",
//       body: new FormData(form),
//     });

//     // Get cart count
//     const res = await fetch("/cart.js");
//     const cart = await res.json();
//     updateCartItemCounts(cart.item_count);

//     // Update cart
//     await updateCartDrawer();

//     // Open cart drawer
//     // openCartDrawer();
//     openCartNotification();
//   });
// });

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

// Intercept add-to-cart forms outside the drawer (product cards, PDP, etc.)
document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  if (form.closest('.cart-drawer')) return;
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const formData = new FormData(form);
    const addRes = await fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" },
    });

    if (!addRes.ok) {
      console.error("Add to cart failed");
      return;
    }

    const added = await addRes.json();
    const qtyJustAdded = getAddedQuantityFromFormData(formData);
    fillCartNotification(added, qtyJustAdded);
    openCartNotification();
    await updateCartDrawer();
  });
});


function getAddedQuantityFromFormData(fd) {
  let total = 0;
  let found = false;

  for (const [key, val] of fd.entries()) {
    if (key === "quantity" || /^items\[\d+\]\[quantity\]$/.test(key)) {
      const n = Number(val);
      if (!Number.isNaN(n) && n > 0) {
        total += n;
        found = true;
      }
    }
  }

  return found ? total : 1;
}
window.getAddedQuantityFromFormData = getAddedQuantityFromFormData;

const CART_NOTIFICATION_DURATION = 3000; // how long one notification stays up
const CART_NOTIFICATION_LEAVE = 280; // must match the CSS transition duration
const CART_NOTIFICATION_MAX = 3; // oldest is dropped once more than this are up

const cartNotificationTimers = new WeakMap();
let pendingCartNotification = null;

function getCartNotificationStack() {
  return document.querySelector(".cart-notification-stack");
}

function fillCartNotification(addedItem, qtyJustAdded = 1) {
  const stack = getCartNotificationStack();
  const template = document.getElementById("cart-notification-template");
  if (!stack || !template) return;

  const slot = template.content.firstElementChild.cloneNode(true);

  const elCount = slot.querySelector(".cart-notification__count");
  const elProduct = slot.querySelector(".cart-notification__product");
  const elVariant = slot.querySelector(".cart-notification__variant-title");

  // Variant title only if product has more than one variant and variant_title exists
  let showVariant =
    addedItem?.product_has_only_default_variant === false &&
    addedItem?.variant_title;

  // Quantity just added

  if (Array.isArray(addedItem)) {
    addedItem = addedItem[0];
    let count = String(qtyJustAdded);

    if (count == 1) {
      if (elCount) elCount.textContent = String(qtyJustAdded) + "x";
      if (elProduct) elProduct.textContent = addedItem?.product_title;
    } else {
      if (elCount) elCount.textContent = count;
      if (elProduct) elProduct.textContent = stack.dataset?.items;
      showVariant = false;
    }
  } else {
    if (elCount) elCount.textContent = String(qtyJustAdded) + "x";
    if (elProduct) elProduct.textContent = addedItem?.product_title;
  }

  if (elVariant) {
    if (showVariant) {
      elVariant.textContent = addedItem.variant_title;
      elVariant.style.display = "";
    } else {
      elVariant.textContent = "";
      elVariant.style.display = "none";
    }
  }

  // Handed over to openCartNotification(), which mounts it and starts its timer.
  pendingCartNotification = slot;
}
window.fillCartNotification = fillCartNotification;

function dismissCartNotification(slot) {
  if (!slot || slot.classList.contains("is-leaving")) return;

  clearTimeout(cartNotificationTimers.get(slot));
  cartNotificationTimers.delete(slot);

  const stack = slot.parentElement;
  slot.classList.add("is-leaving");
  slot.classList.remove("is-open");

  setTimeout(() => {
    slot.remove();
    if (stack && !stack.querySelector(".cart-notification-slot")) {
      stack.classList.remove("notification-visible");
    }
  }, CART_NOTIFICATION_LEAVE);
}

function openCartNotification() {
  const stack = getCartNotificationStack();
  const slot = pendingCartNotification;
  pendingCartNotification = null;
  if (!stack || !slot) return;

  stack.appendChild(slot);
  stack.classList.add("notification-visible");

  // Flush layout so the collapsed start state is computed before expanding,
  // otherwise the browser coalesces both states and skips the transition.
  void slot.offsetHeight;
  slot.classList.add("is-open");

  // Keep the stack from growing without bound.
  const live = stack.querySelectorAll(
    ".cart-notification-slot:not(.is-leaving)"
  );
  for (let i = 0; i < live.length - CART_NOTIFICATION_MAX; i++) {
    dismissCartNotification(live[i]);
  }

  // Each notification runs its own timer, so they expire in the order they came.
  cartNotificationTimers.set(
    slot,
    setTimeout(() => dismissCartNotification(slot), CART_NOTIFICATION_DURATION)
  );
}
window.openCartNotification = openCartNotification;

// Both buttons live inside each cloned notification, so delegate to them.
document.addEventListener("click", (event) => {
  const target = event.target;
  if (!target?.closest) return;

  const closeBtn = target.closest(".cart-notification__close");
  if (closeBtn) {
    dismissCartNotification(closeBtn.closest(".cart-notification-slot"));
    return;
  }

  const ctaBtn = target.closest(".cart-notification__cta");
  if (ctaBtn) {
    // Drop the whole stack - the drawer now shows what the notifications said.
    document
      .querySelectorAll(".cart-notification-slot")
      .forEach(dismissCartNotification);
    openCartDrawer();
  }
});

function discountCodeApplying() {
  const discountCodeApplyBtn = document.getElementById("apply-discount");
  if (!discountCodeApplyBtn) return;

  const wrongCodeText = discountCodeApplyBtn.dataset.wrong;
  const successCodeText = discountCodeApplyBtn.dataset.success;
  const emptyCodeText = discountCodeApplyBtn.dataset.empty;

  const discountMessage = document.getElementById("discount-message");
  const spinner = document.querySelector(".discount-code-spinner");
  const invalidCodes = new Set();

  const discountSectionLabel = document.getElementById(
    "discount-section__label"
  );
  const discountCodeInput = document.getElementById("discount-code");

  // Clear message on focus
  if (discountCodeInput && discountMessage) {
    discountCodeInput.addEventListener("focus", () => {
      discountMessage.textContent = "";
      discountMessage.style.color = "var(--neutral-1000)";
      discountSectionLabel.style.color = "var(--neutral-1000)";
      discountCodeInput.style.border = "1px solid var(--neutral-1000)";
    });
  }

  discountCodeApplyBtn.addEventListener("click", async () => {
    const discountCodeInput = document.getElementById("discount-code");
    const discountCode = discountCodeInput.value.trim();

    discountMessage.textContent = "";

    if (discountCode === "") {
      discountMessage.textContent = emptyCodeText;
      return;
    }

    spinner.style.display = "block";
    try {
      // Fetch current cart
      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();

      let existingCodes = (cart.discount_codes || [])
        .map((dc) => dc.code)
        .filter((code) => code && !invalidCodes.has(code));

      const updatedCodes = [...existingCodes, discountCode];
      const updateRes = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ discount: updatedCodes.join(",") }),
      });
      const updateData = await updateRes.json();
      console.log('updateData', updateData);
      const newCodeEntry = updateData.discount_codes?.find(
        (dc) => dc.code === discountCode
      );

      console.log('newCodeEntry', newCodeEntry);

      if (!newCodeEntry?.applicable) {
        discountMessage.textContent = wrongCodeText;
        discountMessage.style.color = "#A92626";
        discountSectionLabel.style.color = "#A92626";
        discountCodeInput.style.border = "1px solid #A92626";
        invalidCodes.add(discountCode);
        const discountContent = document.querySelector(".cart-drawer__discount-content");
        if(discountContent) {
          discountContent.style.maxHeight = discountContent.scrollHeight + "px";      
        }
      } else {
        discountMessage.textContent = successCodeText;
        discountMessage.style.color = "#939E95";
        discountSectionLabel.style.color = "#939E95";
        discountCodeInput.style.border = "1px solid #939E95";
        const discountContent = document.querySelector(".cart-drawer__discount-content");
        if(discountContent) {
          discountContent.style.maxHeight = discountContent.scrollHeight + "px";      
        }
        const updatedCart = await (await fetch("/cart.js")).json();
        updateCartItemCounts(updatedCart.item_count);
        await updateCartDrawer();
      }
    } catch (err) {
      console.error("Discount error:", err);
      discountMessage.textContent = wrongCodeText;
      discountMessage.style.color = "#A92626";
      discountSectionLabel.style.color = "#A92626";
      discountCodeInput.style.border = "1px solid #A92626";
      const discountContent = document.querySelector(".cart-drawer__discount-content");
      if(discountContent) {
        discountContent.style.maxHeight = discountContent.scrollHeight + "px";      
      }
    } finally {
      spinner.style.display = "none";
    }
  });
}

